import React from 'react';
import 'twin.macro';
import { CommentContent, CommentFooter } from './';

export const CommentFill = ({ comment, topComment, subComment, parentComment }) => {
  return (
    <div>
      {topComment && <div tw='text-brand mb-2 uppercase font-bold'>Topreaguursel</div>}
      <CommentContent comment={comment} subComment={subComment} />
      <CommentFooter
        comment={comment}
        subComment={subComment}
        parentComment={parentComment}
        hideFormHeader
      />
    </div>
  );
};
